import packageInfo from '../package.json';

export const TIMEOUT_BEFORE_REDIRECT = 5000;

export const APP_VERSION = packageInfo.version;
